import { ModuleContentResolver } from '../../contexts'
import { IframeModuleContent, IframeModuleContentInput } from './Iframe.contracts'
import { abstractModuleContentResolver } from '../abstract/abstract-resolver'

export const resolveIframeModuleContent: ModuleContentResolver<IframeModuleContentInput, IframeModuleContent> =
  abstractModuleContentResolver
